export default "__VITE_ASSET__CrRhMO2P__"